import { render } from "./FeaturedTopSpotTyre.vue?vue&type=template&id=70657dea&scoped=true"
import script from "./FeaturedTopSpotTyre.vue?vue&type=script&lang=js"
export * from "./FeaturedTopSpotTyre.vue?vue&type=script&lang=js"

import "./FeaturedTopSpotTyre.vue?vue&type=style&index=0&id=70657dea&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70657dea"]])

export default __exports__